exports = module.exports = require("../../../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".GcTJkLUt-2noYS2SIvzjo{margin-top:auto}", ""]);

// exports
exports.locals = {
	"logoutButton": "GcTJkLUt-2noYS2SIvzjo"
};